export const DEFAULT_DESCRIPTION =
  'Your local travel guide to Selong Belanak, South Lombok — beaches, surf, where to stay, restaurants and things to do.'

const clean = (value) => typeof value === 'string' ? value.trim() : ''

// The format marker lets the renderer ship before the reviewed CMS migration.
// Unmigrated content keeps its existing title until it is explicitly reviewed.
export function buildSeoMetadata({ seo = {}, asPath = '/', siteUrl, preview = false, type = 'website' }) {
  const title = clean(seo?.metaTitle)
  const pageTitle = title
    ? (seo?.titleFormat === 'complete' ? title : `Selong Belanak Lombok | ${title}`)
    : 'Selong Belanak Lombok'
  const description = clean(seo?.metaDesc) || DEFAULT_DESCRIPTION
  const path = asPath.split(/[?#]/)[0].replace(/\/+$/, '') || '/'
  return {
    pageTitle,
    description,
    canonicalUrl: `${siteUrl.replace(/\/+$/, '')}${path}`,
    path,
    shareTitle: clean(seo?.shareTitle) || pageTitle,
    shareDescription: clean(seo?.shareDesc) || description,
    noIndex: preview || seo?.noIndex === true,
    type,
  }
}
